import { getDeviceType } from 'src/common/device/initialize-devices';
import { IDeviceStatusItem } from '../../../common/interfaces/states/IDeviceStatusItem';
import { IDeviceConfigurationDictionary } from '../../interfaces/IDeviceConfigurationDictionary';

export const createDeviceStatusItem = (
  deviceConfig: IDeviceConfigurationDictionary,
): IDeviceStatusItem => {
  const name = deviceConfig.UniqueId;
  const logicalName = deviceConfig.LogicalName;
  const statusItem: IDeviceStatusItem = {
    name,
    logicalName,
    warning: true,
    initialized: false,
    deviceType: getDeviceType(deviceConfig.Type),
    hidePrinterError: deviceConfig.HidePrinterError === 'true',
    minWeight: deviceConfig.MinWeight,
    maxWeight: deviceConfig.MaxWeight,
    minTemperature: deviceConfig.MinTemperature,
    maxTemperature: deviceConfig.MaxTemperature,
    deviceStatus: 'JDEVICE_UNAVAILABLE',
  };
  return statusItem;
};
